// Starter legal templates for DeviceLox — plain language, subject to legal review.
export const LEGAL_UPDATED = "June 2026";

export const TERMS_SECTIONS = [
  {
    heading: "1. Acceptance of Terms",
    body: "By accessing DeviceLox or submitting a device registration, you agree to these Terms of Service. If you do not agree, please do not use the site or submit information.",
  },
  {
    heading: "2. What DeviceLox Does",
    body: "DeviceLox is a device registration intake tool. It lets you submit your contact and device details so they can be kept on file by the business owner. DeviceLox does not remotely lock, control, repair, or manage your devices.",
  },
  {
    heading: "3. Accurate Information",
    body: "You agree to provide accurate, current, and complete information when registering a device or contacting us. Duplicate submissions using the same phone number or email address may be blocked.",
  },
  {
    heading: "4. Consent to Contact",
    body: "By checking the consent box on the registration form, you agree to be contacted about your registration. See our SMS Terms and Privacy Policy for details on how we handle your contact information.",
  },
  {
    heading: "5. Acceptable Use",
    body: "You agree not to misuse the site, submit false information, or attempt to interfere with its operation. We may remove submissions that appear fraudulent or abusive.",
  },
  {
    heading: "6. Limitation of Liability",
    body: "DeviceLox is provided on an 'as is' basis. To the fullest extent permitted by law, we are not liable for indirect or incidental damages arising from your use of the site.",
  },
  {
    heading: "7. Changes to These Terms",
    body: "We may update these Terms from time to time. Continued use of the site after changes take effect constitutes acceptance of the revised Terms.",
  },
  {
    heading: "8. Contact",
    body: "Questions about these Terms can be sent through our Contact page.",
  },
];

export const PRIVACY_SECTIONS = [
  {
    heading: "1. Information We Collect",
    body: "When you register a device, we collect your first name, last name, ZIP code, phone number, email address, and device details (type, brand, model). We also record consent evidence: the date and time of consent, your IP address, a snapshot of the consent text, and the page you submitted from.",
  },
  {
    heading: "2. How We Use Your Information",
    body: "We use your information to keep a record of your device registration, to prevent duplicate submissions, and to contact you about your registration if needed. We do not sell your personal information.",
  },
  {
    heading: "3. Consent Records",
    body: "To document your consent, we store a timestamp, your IP address, the exact consent language you agreed to, and the submission source URL. These records are kept as proof that consent was given.",
  },
  {
    heading: "4. Data Storage & Security",
    body: "Your information is stored in a private database accessible only to the business owner. We take reasonable measures to protect your data, though no method of transmission or storage is completely secure.",
  },
  {
    heading: "5. Data Retention",
    body: "We retain registration records for as long as necessary to fulfill the purposes described here or as required by law.",
  },
  {
    heading: "6. Your Choices",
    body: "You may request access to, correction of, or deletion of your information by contacting us through the Contact page. You may opt out of SMS messages at any time by replying STOP.",
  },
  {
    heading: "7. Changes to This Policy",
    body: "We may update this Privacy Policy periodically. The 'last updated' date above reflects the most recent revision.",
  },
];

export const SMS_SECTIONS = [
  {
    heading: "1. Program Description",
    body: "By providing your phone number and checking the consent box during device registration, you agree to receive calls and SMS/text messages from DeviceLox related to your device registration.",
  },
  {
    heading: "2. Consent (TCPA)",
    body: "Your consent to receive messages, including messages sent using automated technology, is given when you check the consent box on the registration form. Consent is not a condition of any purchase.",
  },
  {
    heading: "3. Message Frequency",
    body: "Message frequency varies based on your registration activity. You will only receive messages relevant to your registration.",
  },
  {
    heading: "4. Message & Data Rates",
    body: "Message and data rates may apply depending on your mobile carrier and plan.",
  },
  {
    heading: "5. Opt-Out",
    body: "You can opt out of SMS messages at any time by replying STOP to any message. After opting out, you will receive a confirmation and no further messages, unless you re-subscribe.",
  },
  {
    heading: "6. Help",
    body: "For help, reply HELP to any message or reach us through the Contact page. Carriers are not liable for delayed or undelivered messages.",
  },
  {
    heading: "7. Privacy",
    body: "Your mobile information is handled according to our Privacy Policy and is not sold to third parties.",
  },
];
